/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AiCommentResponse } from '../models/AiCommentResponse';
import type { CorrectedGrammerResponse } from '../models/CorrectedGrammerResponse';
import type { RegenerateStudentTraitCommentRequest } from '../models/RegenerateStudentTraitCommentRequest';
import type { RegenerateSubjectTraitCommentRequest } from '../models/RegenerateSubjectTraitCommentRequest';
import type { StudentTraitAiCommentRequest } from '../models/StudentTraitAiCommentRequest';
import type { SubjectTraitAiCommentRequest } from '../models/SubjectTraitAiCommentRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OpenAiRestControllerService {
  /**
   * correctGrammar
   * @returns CorrectedGrammerResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static correctGrammarUsingPost({
    input,
  }: {
    /**
     * input
     */
    input: string;
  }): CancelablePromise<CorrectedGrammerResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/openai/correct-grammar',
      body: input,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * generateBulkSubjectTeacherComment
   * @returns any OK
   * @throws ApiError
   */
  public static generateBulkSubjectTeacherCommentUsingGet({
    armId,
    classLevelId,
    subjectId,
    termId,
  }: {
    /**
     * armId
     */
    armId: string;
    /**
     * classLevelId
     */
    classLevelId: string;
    /**
     * subjectId
     */
    subjectId: string;
    /**
     * termId
     */
    termId: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/openai/generate-all-subject-comment',
      query: {
        armId: armId,
        classLevelId: classLevelId,
        subjectId: subjectId,
        termId: termId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * generateComment
   * @returns string OK
   * @throws ApiError
   */
  public static generateCommentUsingGet({
    studentId,
    teacherRole,
    termId,
  }: {
    /**
     * student-id
     */
    studentId: string;
    /**
     * teacherRole
     */
    teacherRole: 'CLASS_TEACHER' | 'HEAD_TEACHER';
    /**
     * term-id
     */
    termId: string;
  }): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/openai/generate-comment',
      query: {
        'student-id': studentId,
        teacherRole: teacherRole,
        'term-id': termId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * generateEyStudentTraitComment
   * @returns AiCommentResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static generateEyStudentTraitCommentUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: StudentTraitAiCommentRequest;
  }): CancelablePromise<AiCommentResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/openai/generate-ey-student-trait-comment',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * generateEySubjectTraitComment
   * @returns AiCommentResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static generateEySubjectTraitCommentUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: SubjectTraitAiCommentRequest;
  }): CancelablePromise<AiCommentResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/openai/generate-ey-subject-trait-comment',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * generateMadrasaSubjectTeacherComment
   * @returns AiCommentResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static generateMadrasaSubjectTeacherCommentUsingPost({
    classLevelId,
    endDate,
    startDate,
    studentId,
    subjectId,
  }: {
    /**
     * classLevelId
     */
    classLevelId: string;
    /**
     * endDate
     */
    endDate: string;
    /**
     * startDate
     */
    startDate: string;
    /**
     * studentId
     */
    studentId: string;
    /**
     * subjectId
     */
    subjectId: string;
  }): CancelablePromise<AiCommentResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/openai/generate-madrasa-subject-teacher-comment',
      query: {
        classLevelId: classLevelId,
        endDate: endDate,
        startDate: startDate,
        studentId: studentId,
        subjectId: subjectId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * generateSubjectTeacherComment
   * @returns string OK
   * @throws ApiError
   */
  public static generateSubjectTeacherCommentUsingGet({
    classLevelId,
    studentId,
    subjectId,
    termId,
  }: {
    /**
     * classLevelId
     */
    classLevelId: string;
    /**
     * studentId
     */
    studentId: string;
    /**
     * subjectId
     */
    subjectId: string;
    /**
     * termId
     */
    termId: string;
  }): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/openai/generate-subject-comment',
      query: {
        classLevelId: classLevelId,
        studentId: studentId,
        subjectId: subjectId,
        termId: termId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * regenerateMadrasaSubjectTeacherComment
   * @returns AiCommentResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static regenerateMadrasaSubjectTeacherCommentUsingPost({
    classLevelId,
    endDate,
    previousComment,
    startDate,
    studentId,
    subjectId,
  }: {
    /**
     * classLevelId
     */
    classLevelId: string;
    /**
     * endDate
     */
    endDate: string;
    /**
     * previousComment
     */
    previousComment: string;
    /**
     * startDate
     */
    startDate: string;
    /**
     * studentId
     */
    studentId: string;
    /**
     * subjectId
     */
    subjectId: string;
  }): CancelablePromise<AiCommentResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/openai/regenerate-madrasa-subject-teacher-comment',
      query: {
        classLevelId: classLevelId,
        endDate: endDate,
        previousComment: previousComment,
        startDate: startDate,
        studentId: studentId,
        subjectId: subjectId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * regenerateStudentTraitsEarlyYearsComment
   * @returns AiCommentResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static regenerateStudentTraitsEarlyYearsCommentUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: RegenerateStudentTraitCommentRequest;
  }): CancelablePromise<AiCommentResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/openai/regenerate-student-traits-early-years-comment',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * regenerateSubjectTraitsEarlyYearsComment
   * @returns AiCommentResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static regenerateSubjectTraitsEarlyYearsCommentUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: RegenerateSubjectTraitCommentRequest;
  }): CancelablePromise<AiCommentResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/openai/regenerate-subject-traits-early-years-comment',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
